import * as React from "react";
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from "./pages/App";
import {createStore} from "redux";
import {rootReducer} from "./store";
import {Provider} from "react-redux";
import {updateToken} from "./store/system/actions";
import config from "./config/config";
import ReactGA from 'react-ga';

ReactGA.initialize(config.googleAnalytics.id);
ReactGA.pageview(window.location.pathname + window.location.search);

const store = createStore(rootReducer);

const token = localStorage.getItem('token');
if(token){
    store.dispatch(updateToken(token));
}

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
